import React, { useState, useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./IndustriesWeServe.css";

// Local Icon image
import FinTechIcon from "../../assets/icons/fintech.png";
import SaasIcon from "../../assets/icons/webappicon-removebg-preview.png";
import ecommerceIcon from "../../assets/icons/ecommerce-removebg-preview.png";
import travelIcon from "../../assets/icons/travelIndustriesWeServe.png";
import HealthcareIcon from "../../assets/icons/healthcareIndustiesWeServe.png";
import resturentsIcon from "../../assets/icons/restaurant.png";
import GovIcon from "../../assets/icons/GovIcon.png"
import EducationIcon from "../../assets/icons/educationIcon.png"

// Local Image files
import SaasImg from "../../assets/industriesWeServe/saas.png";
import FintechImg from "../../assets/industriesWeServe/fintech.png";
import EcommerceImg from "../../assets/industriesWeServe/ecommerceImg.png";
import TravelImg from "../../assets/industriesWeServe/travel01.png";
import HealthcareImg from "../../assets/industriesWeServe/heathcare1.png";
import RestrurentsImg from "../../assets/industriesWeServe/resturent.png";
import GovermentsImage from "../../assets/industriesWeServe/govermentImage.png";
import EducationImage from "../../assets/industriesWeServe/EducationImage.png";
import UpworkImg from "../../assets/industriesWeServe/Upwork-logo.svg-removebg-preview.png";

const ServiceCard = ({
  cardIcon,
  title,
  description,
  imageSrc,
  imageAlt,
  className,
  style,
}) => {
  return (
    <div className="sliderWrapper">
      <div className=" industriesWeServecard relative rounded-3xl bg-blue-900 shadow-2xl hover:shadow-xl hover:-translate-y-2 transition-transform duration-300">
        <div className=" cardIcon absolute top-4 left-4 bg-white rounded-full w-8 h-8 flex items-center justify-center text-black font-semibold">
          {cardIcon}
        </div>
        <div className="cardtitle text-center mt-12 mb-4 text-white text-xl font-bold">
          {title}
        </div>
        <div className="cardDescription text-center px-6 mb-20 text-gray-300">
          {description}
        </div>
        <div className="cardBottomImage absolute bottom-0 left-1/2 transform -translate-x-1/2 mb-[-3rem] w-48">
          <img
            src={imageSrc}
            alt={imageAlt}
            className="rounded-full shadow-2xl cardBottomImg"
          />
        </div>
      </div>
    </div>
  );
};

const IndustriesWeServe = () => {
  const [isPaused, setIsPaused] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const scrollByAmount = 300;

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -scrollByAmount, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: scrollByAmount, behavior: "smooth" });
    }
  };

  return (
    <section className="industriesSection">
      <div className="industriesMainDiv">
        <div className="industriesContainer">
          <h5 className="industriesTitle" data-aos="fade-up">-- Industries We Serve</h5>
          <h1 className="industriesHeading" data-aos="fade-up" data-aos-delay="100">
            Real Time Dealing in all Professional
            <br /> IT Solutions & Services
          </h1>
          <p className="indurtriesDescription" data-aos="fade-up" data-aos-delay="200">
            we develop custom digital solutions for a wide range of industries,
            ensuring that each project meets the unique challenges and demands
            of the sector. Our expertise allows us to create scalable,
            innovative, and high-performing solutions that help businesses grow
            and thrive in the digital world.
          </p>
          <p className="mt-4 text-lg text-gray-400 quote" data-aos="fade-up" data-aos-delay="300">
            “Innovation for developers. Designers. Disruptions.”
          </p>

          {/* Scroll wrapper with buttons */}
          <div className="scroll-wrapper">
            <button className="scroll-button left" onClick={scrollLeft}>←</button>

            <div
              className="scroll-container"
              ref={scrollContainerRef}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
              onMouseDown={() => setIsPaused(true)}
              onMouseUp={() => setIsPaused(false)}
            >
              <div
                className="scroll-content"
                style={{
                  animation: isPaused ? "none" : "scroll-left 0s linear infinite",
                }}
              >
                {[...Array(2)].flatMap(() => [
                  <ServiceCard
                    key="saas"
                    cardIcon={<img src={SaasIcon} alt="saas" className="finTechIcon " />}
                    title="SAAS"
                    description="We build scalable SaaS platforms using Python & Django, delivering cloud-based solutions that drive growth and digital transformation."
                    imageSrc={SaasImg}
                    imageAlt="saas"
                  // style={{width:"210px", height: "280px" }}
                  />,
                  <ServiceCard
                    key="fintech"
                    cardIcon={<img src={FinTechIcon} alt="fintech" className="finTechIcon" />}
                    title="Fintech"
                    description="Our fintech services are designed to be innovative and adaptive based on ongoing technology trends and changing business demands."
                    imageSrc={FintechImg}
                    imageAlt="Fintech"
                  />,
                  <ServiceCard
                    key="ecommerce"
                    cardIcon={<img src={ecommerceIcon} alt="ecommerce" className="finTechIcon" />}
                    title="E-commerce"
                    description="We provide a wide range of E-commerce development services with unique features that provide seamless user experience and smooth customer journeys."
                    imageSrc={EcommerceImg}
                    imageAlt="E-commerce"
                  />,
                  <ServiceCard
                    key="travel"
                    cardIcon={<img src={travelIcon} alt="travel" className="finTechIcon" />}
                    title="Travel"
                    description="Grow your travel business with our custom solutions built for booking, planning and managing travel platforms."
                    imageSrc={TravelImg}
                    imageAlt="Travel"
                  />,
                  <ServiceCard
                    key="healthcare"
                    cardIcon={<img src={HealthcareIcon} alt="healthcare" className="finTechIcon" />}
                    title="Healthcare"
                    description="Our Healthcare services are designed to be innovative and adaptive based on ongoing technology trends and changing business demands."
                    imageSrc={HealthcareImg}
                    imageAlt="Healthcare"
                  />,
                  <ServiceCard
                    key="restaurants"
                    cardIcon={<img src={resturentsIcon} alt="restaurants" className="finTechIcon" />}
                    title="Resturents"
                    description="We craft digital solutions for restaurants that streamline orders, enhance customer engagement, and simplify operations through smart, user-friendly platforms"
                    imageSrc={RestrurentsImg}
                    imageAlt="Resturent"
                  />,

                   <ServiceCard
                    key="Government"
                    cardIcon={<img src={GovIcon} alt="Government" className="finTechIcon" />}
                    title="Government"
                    description="We deliver secure, scalable tech solutions for government projects, enabling efficient administration, digital governance, and citizen-centric services."
                    imageSrc={GovermentsImage}
                    imageAlt="GovermentsImage"
                  />,

                   <ServiceCard
                    key="Education"
                    cardIcon={<img src={EducationIcon} alt="Education" className="finTechIcon" />}
                    title="Education"
                    description="We build intuitive EdTech platforms that support virtual learning, course management, and real-time collaboration for institutions and learners alike."
                    imageSrc={EducationImage}
                    imageAlt="EducationImage"
                  />,
                ])}
              </div>
            </div>

            <button className="scroll-button right" onClick={scrollRight}>→</button>
          </div>

          <div className="text-center mt-12 upworkMainDiv" data-aos="fade-up" data-aos-delay="400">
            <p className="verifiedUpwork text-gray-500">
              Verified by:{" "}
              <span className="font-semibold">
                <img src={UpworkImg} alt="UpworkImg" className="UpworkImg" data-aos="flip-left" />
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesWeServe;
